$(document).ready(function () {
  function setupProductSelection($container) {
    const $radioInputs = $container.find('.radio__inputs input[type="radio"]');
    const $selectPopoutToggleButton = $container.find(".select__fieldset");
    const $productOption = $container.find("input[data-popout-input]");
    const $submitButtons = $container.find(
      ".product__submit__buttons button, .product__submit__buttons .product__submit__quick"
    );
    const $productSubmitButtons = $container.find(
      ".product__block__buttons .product__submit__buttons"
    );

    if (!$radioInputs.length && !$selectPopoutToggleButton.length) return;

    function isAnyRadioChecked() {
      return $radioInputs.is(":checked");
    }

    function toggleButtons(enable) {
      $submitButtons.css("pointer-events", enable ? "auto" : "none");
    }

    function toggleErrorMessage(show) {
      console.log(show);
      const $errorMessage = $container.find("#variantError");
      const animationDuration = 300;

      if (show && !$errorMessage.length) {
        $("<div>", {
          id: "variantError",
          class: "errors",
          text: "Select an option to proceed with the cart.",
          css: {
            color: "red",
            display: "none",
            opacity: 0,
            marginBottom: "10px",
          },
        })
          .insertBefore($container.find(".product__submit__buttons"))
          .slideDown(animationDuration)
          .animate({ opacity: 1 }, animationDuration);
        $container.find(".product__submit__buttons");
      } else if (!show && $errorMessage.length) {
        $errorMessage.animate({ opacity: 0 }, animationDuration, function () {
          $(this).slideUp(animationDuration, function () {
            $(this).remove();
          });
        });
        $container.find(".product__submit__buttons");
      }
    }

    function updateButtonsState() {
      const isProductOptionEmpty = $.trim($productOption.val()) === "";
      toggleButtons(!isProductOptionEmpty);
      if (!isProductOptionEmpty) toggleErrorMessage(false);
    }

    // Initial setup
    toggleButtons(isAnyRadioChecked());
    $productOption.val("");
    updateButtonsState();

    // Event listeners
    $radioInputs.on("change", function () {
      toggleButtons(true);
      $container.find("#showSelectedSize").show();
      if ($("#variantError").length > 0) {
        // Remove the #variantError div slowly
        $("#variantError").fadeOut(500, function () {
          $(this).remove();
        });
      }
    });

    $productSubmitButtons.on("click", function (event) {
      if (
        ($radioInputs.length && !isAnyRadioChecked()) ||
        ($selectPopoutToggleButton.length && $productOption.val().trim() === "")
      ) {
        event.preventDefault();
        toggleErrorMessage(true);
      } else {
        toggleErrorMessage(false);
      }
    });

    if ($productOption.length) {
      $productOption.on("change", updateButtonsState);
    }

    // Delay to uncheck radio buttons
    setTimeout(
      () => $container.find(".radio__button input").prop("checked", false),
      50
    );

    // Set cursor style for submit buttons
    $container.find(".product__submit__buttons").css("cursor", "pointer");
  }

  // Initial setup for the main product form
  setupProductSelection($(".product__main__content"));

  // Function to initialize the click event
  function initProductClipBtnClick() {
    $(".product-clip__btn").on("click", function (e) {
      e.preventDefault();
      setTimeout(() => {
        const $quickviewForm = $(".quickview__form");
        if ($quickviewForm.length) {
          // Enable pointer events for the quickview form immediately
          $quickviewForm
            .find(".product__form__inner button")
            .css("opacity", "unset");
          // Re-run the setup function after a delay, specifically for the quickview form
          setupProductSelection($quickviewForm);
        } else {
          console.log("Quickview form not found");
        }
      }, 1000);
    });
  }

  // Interval to check for the existence of .product-clip__btn
  const intervalId = setInterval(() => {
    if ($(".product-clip__btn").length) {
      initProductClipBtnClick();
    }
  }, 1000);

  // Function to check and initialize the product clip button after cart drawer opens
  function checkAndInitProductClipBtn() {
    if ($(".product-clip__btn").length) {
      initProductClipBtnClick();
    } else {
      const intervalId = setInterval(() => {
        if ($(".product-clip__btn").length) {
          initProductClipBtnClick();
        }
      }, 500); // Check more frequently (every 500ms)
    }
  }

  // Attach the click event listener to the navlink--cart to trigger the check
  $(".navlink--cart").on("click", function () {
    // After the drawer is opened, check and initialize the buttons
    setTimeout(() => {
      checkAndInitProductClipBtn();
    }, 1000); // Adjust the timeout based on how long it takes for the drawer to load
  });
});
